import axios from 'axios';
import { store } from 'store/store';
import resolvePath from 'utils/resolvePath';
// Action
const CLEAR = 'tag/clear';
const GET_TAG_FILTER = 'tag/getTagFilter';
const GET_TAG_FILTER_REQUEST = 'tag/getTagFilterRequest';
const GET_TAG_FILTER_SUCCESS = 'tag/getTagFilterSuccess';
const GET_TAG_FILTER_FAILURE = 'tag/getTagFilterFailure';
// Action Creator
export const clear = () => {
    return {
        type: CLEAR,
    };
};
export const getTagFilterRequest = () => {
    return {
        type: GET_TAG_FILTER_REQUEST,
    };
};
export const getTagFilterSuccess = (tagFilter) => {
    return {
        payload: {
            tagFilter,
        },
        type: GET_TAG_FILTER_SUCCESS,
    };
};
export const getTagFilterFailure = (error) => {
    return {
        payload: {
            error,
        },
        type: GET_TAG_FILTER_FAILURE,
    };
};
export const getTagFilter = (authToken, tagName, page) => {
    const loadTagFilteredTeachers = (dispatch) => {
        const config = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
            params: {
                tag_name: tagName,
                page: page + 1,
                per_page: 10,
            },
        };
        return axios
            .get(resolvePath.api(`tags`), config)
            .then((response) => dispatch(getTagFilterSuccess(response.data ? response.data : initialState.tagFilter)))
            .catch((error) => {
            dispatch(getTagFilterFailure(error));
            throw new Error();
        });
    };
    loadTagFilteredTeachers(store.dispatch);
    return {
        type: GET_TAG_FILTER,
    };
};
const initialState = {
    error: null,
    tagFilter: {
        tag: null,
        users: [],
    },
    page: 0,
};
export default (state = initialState, action) => {
    switch (action.type) {
        case CLEAR: {
            return Object.assign(Object.assign({}, state), { tagFilter: initialState.tagFilter, page: 0 });
        }
        case GET_TAG_FILTER_REQUEST: {
            return Object.assign({}, state);
        }
        case GET_TAG_FILTER_SUCCESS: {
            return Object.assign(Object.assign({}, state), { tagFilter: {
                    tag: action.payload.tagFilter.tag,
                    users: [...state.tagFilter.users, ...action.payload.tagFilter.users],
                }, page: state.page + 1 });
        }
        case GET_TAG_FILTER_FAILURE: {
            return Object.assign(Object.assign({}, state), { error: action.payload.error });
        }
        default: {
            return state;
        }
    }
};
